import script from "./SalesMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesMenu.vue?vue&type=script&setup=true&lang=js"

import "./SalesMenu.vue?vue&type=style&index=0&id=28c6243d&lang=scss"

const __exports__ = script;

export default __exports__